import { API_URL } from '../../config/env';
import { loginPathWithReturn } from '../../utils/authRedirect';

function resolveUrl(pathOrUrl) {
  if (!pathOrUrl) return API_URL;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${API_URL}${path}`;
}

export default function apiClient(pathOrUrl, options = {}) {
  const token = localStorage.getItem('token');
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };

  return fetch(resolveUrl(pathOrUrl), {
    ...options,
    headers
  }).then((res) => {
    const path = String(pathOrUrl || '');
    const skipRedirect =
      path.includes('/api/auth/login') ||
      path.includes('/api/auth/set-password') ||
      path.includes('/api/auth/accept-invite') ||
      path.includes('/api/auth/logout');
    if ((res.status === 401 || res.status === 403) && !skipRedirect) {
      localStorage.removeItem('token');
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.href = loginPathWithReturn(
          window.location.pathname + window.location.search
        );
      }
      throw new Error(res.status === 401 ? 'Unauthorized' : 'Forbidden');
    }
    return res;
  });
}

export { API_URL };
